<template>
	<p class="inline-paragraph">
		{{ documentName }}:
	</p>
</template>

<script>

function documentName() {
	if (this.documentId === 1) {
		return 'DNI';
	} else if (this.documentId === 2)	{
		return 'Pasaporte';
	} else if (this.documentId === 3)	{
		return 'C. Extranjería';
	}	else if (this.documentId === 4)	{
		return 'RUC';
	} else if (this.documentId === 5) {
		return 'C.I. País Residencia';
	}
	return ' - ';
}

export default {
	name: 'app-type-document',
	computed: {
		documentName,
	},
	props: {
		documentId: {
			type: Number,
			default: 0,
		},
	},
};
</script>

<style lang="scss" scoped>
.inline-paragraph {
	display: inline;
}
</style>




// WEBPACK FOOTER //
// app-type-document.vue?8790db1e